import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  outline: 0;\n  box-shadow: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-top: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  border-right: ", ";\n  cursor: pointer;\n  text-decoration: none;\n\n  ", "\n  ", "\n  ", "\n  ", "\n\n  ", " {\n    width: ", ";\n    height: ", ";\n    font-size: ", ";\n  }\n\n  cursor: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  pointer-events: none;\n  user-select: none;\n  font-size: ", ";\n\n  & + ", " {\n    margin-right: 0;\n    margin-left: 4px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 4px;\n  color: inherit;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { variant, space, layout } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Icon } from '../icon/Icon';
var buttonSizeStyle = variant({
  prop: 'size',
  key: 'buttons.size'
});
var buttonStyle = variant({
  key: 'buttons'
});
var StyledIcon = styled(Icon)(_templateObject());
var Text = styled.span(_templateObject2(), themeGet('button.fontSize'), StyledIcon);
export var StyledButton = styled.button(_templateObject3(), themeGet('button.boxShadow'), themeGet('button.border'), themeGet('button.borderRadius'), themeGet('button.borderTop'), themeGet('button.borderBottom'), themeGet('button.borderLeft'), themeGet('button.borderRight'), buttonStyle, buttonSizeStyle, space, layout, StyledIcon, themeGet('button.iconSize'), themeGet('button.iconSize'), themeGet('button.iconSize'), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
/**
 * @typedef ButtonProps
 * @property {'default' | 'primary' | 'link'} variant
 * @property {'default' | 'small' | 'large'} size
 * @property {string} prefixIcon
 * @property {string} suffixIcon
 */

/**
 * @param {ButtonProps} props
 */

export var Button =
/*#__PURE__*/
forwardRef(function Button(_ref2, ref) {
  var variant = _ref2.variant,
      size = _ref2.size,
      children = _ref2.children,
      prefixIcon = _ref2.prefixIcon,
      suffixIcon = _ref2.suffixIcon,
      rest = _objectWithoutProperties(_ref2, ["variant", "size", "children", "prefixIcon", "suffixIcon"]);

  return (
    /*#__PURE__*/
    React.createElement(StyledButton, _extends({
      ref: ref,
      variant: variant,
      size: size
    }, rest), prefixIcon &&
    /*#__PURE__*/
    React.createElement(StyledIcon, {
      name: prefixIcon
    }),
    /*#__PURE__*/
    React.createElement(Text, null, children), suffixIcon &&
    /*#__PURE__*/
    React.createElement(StyledIcon, {
      name: suffixIcon
    }))
  );
});
Button.defaultProps = {
  variant: 'default',
  size: 'default'
};